import { FileSpreadsheet, Gauge, Network, Route } from 'lucide-react';

import { MetricCard } from '@/components/MetricCard';
import { Card } from '@/components/ui/Card';
import { formatCapacity } from '@/lib/format';

export function HeroPanel({
  rows,
  edges,
  nodes,
  maxCapacity,
}: {
  rows: number;
  edges: number;
  nodes: number;
  maxCapacity: number | null;
}) {
  return (
    <Card className="border-0 bg-white p-4 text-slate-900 shadow-2xl shadow-slate-950/15 dark:bg-slate-900 dark:text-white">
      
      <h1 className="mt-3 text-2xl font-semibold tracking-tight">Network Route Planner</h1>
      <p className="mt-2 text-xs leading-tight text-slate-600 dark:text-slate-300">
        Загружай XLSX, превращай сервисы в граф и ищи оптимальные маршруты по latency, стоимости,
        числу хопов, balanced score или Pareto frontier.
      </p>

      <div className="mt-4 grid gap-2 sm:grid-cols-2 xl:grid-cols-4">
        <MetricCard label="Строк в листе" value={String(rows)} icon={<FileSpreadsheet className="h-3.5 w-3.5" />} />
        <MetricCard label="Рёбер" value={String(edges)} icon={<Route className="h-3.5 w-3.5" />} />
        <MetricCard label="Узлов" value={String(nodes)} icon={<Network className="h-3.5 w-3.5" />} />
        <MetricCard label="Max capacity" value={formatCapacity(maxCapacity)} icon={<Gauge className="h-3.5 w-3.5" />} />
      </div>
    </Card>
  );
}
